<template>
  <div class="analytics-page">
    <MainHeader/>
    <Content />
    <Footer/>
  </div>
</template>

<script>
import MainHeader from '@/components/layouts/MainHeader.vue';
import Footer from "@/components/layouts/Footer.vue";
import Content from "@/components/analytics/AnalyticsContent.vue";

export default {
  name: 'AnalyticsPage',
  components: {
    Content,
    MainHeader,
    Footer
  },
};
</script>

<style scoped>
</style>